import { render, staticRenderFns } from "./RegularCustomer.vue?vue&type=template&id=2815996a&scoped=true"
import script from "./RegularCustomer.vue?vue&type=script&lang=js"
export * from "./RegularCustomer.vue?vue&type=script&lang=js"
import style0 from "./RegularCustomer.vue?vue&type=style&index=0&id=2815996a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2815996a",
  null
  
)

export default component.exports